import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import FormRow from "../../components/Row/FormRow";
import SelectRow from "../../components/Select/SelectRow";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";
import { Scopes } from "../../shared/scopes.enum.js";
import { JobStatus } from "../../shared/job-statuses.enum.js";
import SelectModal from "./components/SelectModel.jsx";

export default class MerchantUserAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      user: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        cityId: "", // Ensure cityId is in the user state
      },
      scopes: [],
      scopeslist: [],
      allowedJobStatuses: [],
      jobStatusList: [],
      citylist: [],
      loading: false,
      isScopeModalOpen: false,
      isJobStatusModalOpen: false,
      passModel: false,
    };

    this.engine = new RequestEngine();
    this.toggleScopeModal = this.toggleScopeModal.bind(this);
    this.toggleJobStatusModal = this.toggleJobStatusModal.bind(this);
    this._isMounted = false; // Add a flag to track the component's mount status
  }

  componentDidMount() {
    this._isMounted = true; // Set the flag to true when the component mounts
    const edit = this.props.location.data;
    const { selectedMerchant } = this.props.match.params;
    this.pathname = `merchants/${selectedMerchant}/users`;

    if (edit) {
      console.log(edit);
      this.setState({
        ...edit,
        id: edit.id || "",
        scopes: edit.scope
          ? edit.scope.map((scope) => ({ value: scope, label: scope }))
          : [],
        allowedJobStatuses: edit.allowedJobStatuses
          ? edit.allowedJobStatuses.map((key) => {
              return {
                value: key,
                label: strings[key],
              };
            })
          : [],
        user: {
          firstName: edit.user.firstName || "",
          lastName: edit.user.lastName || "",
          email: edit.user.email || "",
          phoneNumber: edit.user.phonenumber || "",
          password: "",
          cityId: edit.user.cityId || "", // Make sure cityId is populated
        },
      });
    }
    this.prepareData();
  }

  componentWillUnmount() {
    this._isMounted = false; // Set the flag to false when the component unmounts
  }

  async prepareData() {
    const scopes = Object.entries(Scopes).map(([key, value]) => {
      return {
        value: value,
        label: value,
      };
    });
    const jobStatusList = Object.entries(JobStatus).map(([key, value]) => {
      return {
        value: key,
        label: strings[value],
      };
    });
    this.setState({ scopeslist: scopes, jobStatusList, passModel: true });
    try {
      let responseuni = await this.engine.getItemlistDirect("cities");
      if (responseuni && this._isMounted) {
        // Check if the component is still mounted before updating the state
        const data = responseuni.data.items;
        const citylist = data.map((p) => ({ value: p.id, label: p.name }));
        this.setState({ citylist });
      }
    } catch (error) {
      if (this._isMounted) {
        console.error("Error loading cities", error);
      }
    }
  }

  // For handling regular form inputs
  changeInput = (e, myname) => {
    if (e && e.target) {
      // Handle standard inputs (e.g., text, email)
      const { name, value } = e.target;
      const trimmedValue = typeof value === "string" ? value.trim() : value;
      this.setState((prevState) => ({
        user: {
          ...prevState.user,
          [myname || name]: trimmedValue,
        },
      }));
    } else if (e && e.value) {
      // Handle custom inputs (e.g., dropdowns)
      const { name, value } = e;
      const trimmedValue = typeof value === "string" ? value.trim() : value;
      this.setState((prevState) => ({
        user: {
          ...prevState.user,
          [myname || name]: trimmedValue,
        },
      }));
    }
  };

  // Handle select changes (for multi-select)
  handleSelectChange = (selectedOption, field) => {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        [field]: selectedOption ? selectedOption.value : "",
      },
    }));
  };

  // Handle form submit after validation
  handleValidSubmit = async () => {
    // this.setState({ loading: true });
    const { user, scopes, allowedJobStatuses, ...data } = this.state;
    const scopelist = scopes.map((scope) => {
      return scope.value;
    });
    const jobStatusList = allowedJobStatuses.map((status) => {
      return status.value;
    });
    const payload = {
      scopes: scopelist,
      allowedJobStatuses: jobStatusList,
      user: {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        password: user.password,
        phoneNumber: user.phoneNumber,
        cityId: user.cityId,
      },
    };

    const { selectedMerchant } = this.props.match.params;
    let response;
    try {
      if (this.state.id) {
        delete payload.user.password;
        delete payload.user.cityId;

        response = await this.engine.updateItem(this.pathname, this.state.id, {
          ...payload,
          version: this.state.version,
        });
      } else {
        response = await this.engine.saveItem(this.pathname, payload);
      }
      if ((response && response.status === 201) || response.status === 200) {
        this.props.history.push(`/admin/merchant/${selectedMerchant}/users`);
      } else {
        alert("An error occurred while saving the merchant user.");
      }
    } catch (error) {
      alert("An error occurred while processing your request.");
    } finally {
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    }
  };
  toggleScopeModal() {
    this.setState((prevState) => ({
      isScopeModalOpen: !prevState.isScopeModalOpen,
    }));
  }

  toggleJobStatusModal() {
    this.setState((prevState) => ({
      isJobStatusModalOpen: !prevState.isJobStatusModalOpen,
    }));
  }

  handleScopeSave = (selectedScopes) => {
    this.setState({ scopes: selectedScopes });
  };

  handleJobStatusSave = (selectedJobStatuses) => {
    this.setState({ allowedJobStatuses: selectedJobStatuses });
  };

  render() {
    const {
      id,
      loading,
      scopes,
      scopeslist,
      user,
      citylist,
      allowedJobStatuses,
      jobStatusList,
      isScopeModalOpen,
      isJobStatusModalOpen,
    } = this.state;
    return (
      <div className="content english">
        <Row>
          <Col md="12">
            <AvForm
              onValidSubmit={this.handleValidSubmit}
              className="form-horizontal"
              id="TypeValidation"
            >
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">{strings.information}</CardTitle>
                </CardHeader>
                <CardBody>
                  <FormRow
                    label={strings.firstname}
                    name="firstName"
                    data={user.firstName}
                    changeInput={this.changeInput}
                  />
                  <FormRow
                    label={strings.lastname}
                    name="lastName"
                    data={user.lastName}
                    changeInput={this.changeInput}
                  />
                  <FormRow
                    label={strings.email}
                    name="email"
                    data={user.email}
                    changeInput={this.changeInput}
                  />
                  <FormRow
                    label={strings.phone}
                    name="phoneNumber"
                    data={user.phoneNumber}
                    changeInput={this.changeInput}
                  />
                  {!id && (
                    <FormRow
                      label={strings.password}
                      name="password"
                      data={user.password}
                      changeInput={this.changeInput}
                    />
                  )}
                  {!this.state.id && (
                    <SelectRow
                      label={strings.city}
                      name="cityId"
                      value={
                        citylist.find((city) => city.value === user.cityId) ||
                        {}
                      }
                      data={citylist}
                      changeInput={this.handleSelectChange}
                    />
                  )}

                  <Button color="primary" onClick={this.toggleScopeModal}>
                    {`${strings.select} ${strings.scopes}`}
                  </Button>

                  <Button color="primary" onClick={this.toggleJobStatusModal}>
                    {`${strings.select} ${strings.allowedjobstatuses}`}
                  </Button>

                  {scopes.length > 0 && (
                    <div className="mt-4">
                      <strong className="d-block mb-2">
                        {`${strings.selected} ${strings.scopes}`}:
                      </strong>
                      <Row>
                        {scopes.map((scope) => (
                          <Col md="6" key={scope.value} className="mb-3">
                            <div className="d-flex align-items-center p-3 bg-light border rounded">
                              <span className="font-weight-bold">
                                {scope.label}
                              </span>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )}

                  {allowedJobStatuses.length > 0 && (
                    <div className="mt-4">
                      <strong className="d-block mb-2">
                        {`${strings.selected} ${strings.allowedjobstatuses}`}:
                      </strong>
                      <Row>
                        {allowedJobStatuses.map((status) => (
                          <Col md="6" key={status.value} className="mb-3">
                            <div className="d-flex align-items-center p-3 bg-light border rounded">
                              <span className="font-weight-bold">
                                {status.label}
                              </span>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )}

                  {this.state.passModel && (
                    <>
                      <SelectModal
                        isOpen={isScopeModalOpen}
                        toggle={this.toggleScopeModal}
                        title={`${strings.select} ${strings.scopes}`}
                        itemsList={scopeslist}
                        selectedItems={scopes}
                        onSave={this.handleScopeSave}
                      />
                      <SelectModal
                        isOpen={isJobStatusModalOpen}
                        toggle={this.toggleJobStatusModal}
                        title={`${strings.select} ${strings.allowedjobstatuses}`}
                        itemsList={jobStatusList}
                        selectedItems={allowedJobStatuses}
                        onSave={this.handleJobStatusSave}
                      />
                    </>
                  )}
                </CardBody>
                <CardFooter className="text-center">
                  <ButtonLoader color="primary" loading={loading}>
                    {strings.save}
                  </ButtonLoader>
                </CardFooter>
              </Card>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}
